import { faCircleNotch } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Button, styled, Typography } from "@mui/material"
import { useApiPost } from "auth/useApi2"
import theme from "css/theme/light"
import { apiEndpoints } from "generated/apiEndpoints"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

const StyledBigButton = styled(Button)({
  borderRadius: "12px",
  padding: "32px 30px",
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  justifyContent: "space-between",
  boxShadow: "none",
  color: theme.palette.text.primary,
  width: "100%",
  "&:hover": {
    boxShadow: "none"
  }
})

const StyledIconStart = styled(FontAwesomeIcon)({
  fontSize: "24px",
  color: theme.palette.primary[800]
})

const StyledIconEnd = styled(FontAwesomeIcon)({
  fontSize: "12px",
  color: theme.palette.secondary.main
})

function BplTokenLink(props) {
  const { to, link, label, variant, color, bigButton, iconStart, iconEnd } = props
  const [bplLinkResult, linkToBplApi] = useApiPost()
  const history = useHistory()
  const { t } = useTranslation()

  const linkToTp = () => {
    history.push(link)
  }

  const linkToBpl = () => {
    linkToBplApi(apiEndpoints.planning.linktoken)
  }

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer")
  }

  useEffect(() => {
    if (bplLinkResult.status === 2 && bplLinkResult.data.token !== null) {
      var url = bplLinkResult.data.bplUrl
        .concat("/login.aspx?id=")
        .concat(bplLinkResult.data.id)
        .concat("&t=")
        .concat(encodeURIComponent(bplLinkResult.data.token))
        .concat("&ReturnURL=")
        .concat(encodeURIComponent(bplLinkResult.data.bplUrl.concat("/").concat(to)))

      openInNewTab(url)
    }
  }, [bplLinkResult])

  return bigButton ? (
    <StyledBigButton
      {...props}
      variant={variant && variant}
      color={color ? color : "primary"}
      result={bplLinkResult}
      onClick={to ? linkToBpl : link ? linkToTp : null}
      endIcon={iconEnd && <StyledIconEnd icon={iconEnd} />}>
      <Box gap={3} display="flex" alignItems="center">
        <Box display="flex" justifyContent="center" sx={{ width: "40px" }}>
          {iconStart && <StyledIconStart icon={iconStart} />}
        </Box>
        <Typography fontWeight="500" variant="bodySmall">
          {bplLinkResult.status === 1
            ? t("global.loading", "Loading")
            : label
            ? label
            : to
            ? t("planning.go_to_BPL", "Go to BPL")
            : t("planning.go_to_TP", "Go to Transportportalen")}
        </Typography>
      </Box>
    </StyledBigButton>
  ) : (
    <Button
      {...props}
      variant={variant ? variant : "contained"}
      color={color && color}
      result={bplLinkResult}
      onClick={linkToBpl}
      startIcon={
        bplLinkResult.status === 1 ? (
          <FontAwesomeIcon spin icon={faCircleNotch} />
        ) : (
          iconStart && <FontAwesomeIcon icon={iconStart} />
        )
      }>
      {bplLinkResult.status === 1
        ? t("global.loading", "Loading")
        : label
        ? label
        : t("planning.go_to_BPL", "Go to BPL")}
    </Button>
  )
}

export default BplTokenLink
